var data = {
  "width": 24,
  "height": 24,
  "body": "<g id=\"evaStarFill0\"><g id=\"evaStarFill1\"><path id=\"evaStarFill2\" fill=\"currentColor\" d=\"M17.56 21a1 1 0 0 1-.46-.11L12 18.22l-5.1 2.67a1 1 0 0 1-1.45-1.06l1-5.63l-4.12-4a1 1 0 0 1-.25-1a1 1 0 0 1 .81-.68l5.7-.83l2.51-5.13a1 1 0 0 1 1.8 0l2.54 5.12l5.7.83a1 1 0 0 1 .81.68a1 1 0 0 1-.25 1l-4.12 4l1 5.63a1 1 0 0 1-.4 1a1 1 0 0 1-.62.18Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;